import { FeedCurve } from "../../../../Services";
import { ComponentAmount } from "./getMixtureDataPerComponent";

const constructDataMap = (feedCurve: FeedCurve) => {
  let firstDay = 0;
  let lastDay = 0;
  let lastDayTracker = 0;
  let feedDayTracker = 0;
  const milestonesFirstDay: number[] = [];
  const dataMap = new Map<number, ComponentAmount[]>(feedCurve.components?.map((component) => ([component.componentId, []])));
  feedCurve.milestones?.sort((milestoneA, milestoneB) => (milestoneA.milestoneIndex-milestoneB.milestoneIndex)).forEach((milestone, milestoneIndex) => {
    lastDayTracker = milestoneIndex === 0 ? feedDayTracker : feedDayTracker+1;
    if (milestoneIndex !== 0) {
      milestonesFirstDay.push(lastDayTracker);
    }
    milestone.feedDays?.forEach((feedDay, dayIndex) => {
      if (milestoneIndex === 0 && dayIndex === 0) {
        firstDay = feedDay.day;
        milestonesFirstDay.push(firstDay);
      }
      feedDayTracker = (feedDay.day + lastDayTracker);
      dataMap.forEach((componentData, componentId) => {
        const dayComponent = feedDay.dayComponents.find((dayComponent) => dayComponent.componentId === componentId);
        if (componentData) {
          componentData.push({day: feedDay.day+lastDayTracker, amount: dayComponent ? dayComponent.amount/1000 : 0, dayOffset: lastDayTracker});
          lastDay = feedDay.day+lastDayTracker;
        }
      })
    } )
  });

  const totalAmounts = Array.from(dataMap.values()).reduce((acc,array) => {
    array.forEach((value, index) => {
      if (acc[index]) {
        acc[index] += value.amount
        return;
      }
      acc[index] = value.amount;
    })
    return acc
  }, [] as number[])

  if (totalAmounts.length === 0) {
    totalAmounts[0] = 0;
  }
  const maxAmount = Math.max(...totalAmounts);
  const minAmount = Math.min(...totalAmounts);
  return {dataMap, lastDay, firstDay, maxAmount , minAmount, milestonesFirstDay}
}

export default constructDataMap